import React from "react";
import { useLocation } from "react-router-dom";
import NavigationTabs from "_shared/components/NavigationTabs/NavigationTabs";
import styles from "./AccountTabs.module.scss";

export const tabs = [
  {
    label: "Profile",
    key: "profile",
    path: "/account/profile",
  },
  {
    label: "Manage Subscriptions",
    key: "subscriptions",
    path: "/account/manage-subscriptions",
  },
  {
    label: "Payment",
    key: "payment",
    path: "/account/payment",
  },
  // {
  //   label: "Integrations",
  //   key: "integrations",
  //   path: "/account/integrations",
  // },
];

const AccountTabs: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <div data-testid="account-tabs" className={styles.container}>
      <NavigationTabs>
        {tabs.map((tab, i) => (
          <NavigationTabs.Tab
            key={tab.key}
            id={tab.key}
            index={i}
            label={tab.label}
            selected={pathname === tab.path}
            path={tab.path}
          />
        ))}
      </NavigationTabs>
    </div>
  );
};

export default AccountTabs;
